window.reachGoal = function (id, type = 'submit') {
    if (typeof yaCounter !== 'undefined') {
        yaCounter.reachGoal(id);
    }

    if (typeof dataLayer !== 'undefined')
    {
        if (type === 'virtual') {
            dataLayer.push({
                event: 'virtual-page-view',
                virtualPageURL: '/virtual/' + id,
                virtualPageTitle: undefined,
            });
        } else {
            dataLayer.push({
                event: 'send-to-ga',
                eventCategory: 'submit',
                eventAction: id,
                eventLabel: undefined,
                eventValue: undefined,
            });
        }
    }
}
